import { StoreEntityType } from 'ngx-unificator/store';
import { HttpStatus } from '../services/response-handler.service';

export type HalloweenPageResponse = HalloweenPageType[] | { statusCode: HttpStatus };

export type HalloweenStateType = {
  page: HalloweenPageType;
  currentBonus: CurrentBonusItemType;
  currentPrize: CurrentPrizeType;
  isUserCanParticipateInPromo: boolean;
  isUserCanPartiallyParticipateInPromo: boolean;
  isUserAlreadyActivatedPromoLootbox: boolean;
  isAllWelcomePackClaimed: boolean;
  isLoadedPromo: boolean;
  isPromoInitialized: boolean;
  isShowWelcomeModalPromo: boolean;
  isSpinFinished: boolean;
  isDisableSpin: boolean;
  showTryTomorrowOnDestroy: boolean;
  isWelcomeModalOpened: boolean;
  slots: SlotType;
};

export type HalloweenPageType = {
  Title: string;
  Description: string;
  Prize: string;
  PrizeDesc: string;
  UnlockTitle: string;
  HowItWorksTitle: string;
  HowItWorksSteps: { title: string }[];
  GamesTitle: string;
  GamesDesc: string;
  TournamentsTitle: string;
  TelegramTitle: string;
  TelegramLink: string;
  TryTomorrowTitle: string;
  TryTomorrowDesc: string;
  BonusShopTitle: string;
  BonusShopDesc: string;
  BonusShopLink: string;
  DailyMissionDoneTitle: string;
  DailyMissionDoneDesc: string;
  HowWorksTerms: string;
  GeneralTerms: string;
  DepositRuleTitle: string;
  DepositRuleDesc: string;
  SpinTitle: string;
  SpinDesc: string;
  WinTitle: string;
  WinDesc: string;
  GameCategory: number;
  unpublishAt: any;
  publishAt: any;
  Prizes: { fs: number; image: number }[];
  SocialList: { type: string; link: string }[];
  HuntModal: {
    HuntModal: {
      BonusGroupClaimed: string;
      BonusGroupCatch: string;
      Title: string;
      Desc: string;
      Rule: string;
      AboutPromo: string;
      CongratsTitle: string;
      Prize: string;
      FinalDesc: string;
      Code: string;
      DepositRule: string;
      Terms: string;
      PromoTitle: string;
      PromoDesc: string;
      PromoRule: string;
      PromoFirstDesc: string;
      PromoSecondDesc: string;
      PromoThirdDesc: string;
    };
  };
  isDisablePromo?: boolean;
  OfferDesc?: string;
  ButtonText?: string;
  MetaTitle?: string;
  MetaDesc?: string;
  SeoContent?: string;
};

export type CurrentBonusItemType = {
  fs?: any;
  cash?: any;
  welcomeLootbox?: any;
  promoIssuedLootbox?: any;
};

export type CurrentPrizeType = {
  fs_count?: number;
  cash?: any;
};

export type SlotType = {
  prizes?: SlotPrizeItemType[];
  finalPrize?: SlotPrizeItemType;
};

export type SlotPrizeItemType = {
  fs: number;
  image: string;
};

export const halloweenStore: StoreEntityType<HalloweenStateType> = {
  page: null,
  currentBonus: null,
  currentPrize: null,
  isUserCanParticipateInPromo: false,
  isUserCanPartiallyParticipateInPromo: false,
  isUserAlreadyActivatedPromoLootbox: false,
  isAllWelcomePackClaimed: false,
  isLoadedPromo: false,
  isShowWelcomeModalPromo: false,
  isSpinFinished: false,
  isDisableSpin: false,
  showTryTomorrowOnDestroy: false,
  isWelcomeModalOpened: false,
  isPromoInitialized: false,
  slots: {
    prizes: [],
    finalPrize: null,
  },
};

export type HalloweenStoreEntity = typeof halloweenStore;
